import React, { useEffect, useReducer } from "react";
import { images } from "../../../../../assets/images";
import "../../../styles/Preview.css";

import { ICONS } from "../../../../../assets/icons";
import TemplatePreview from "../../../../../components/commonComponents/templates/TemplatePreview";
import "../../../styles/Broadcast.css";

import { useFileUploader } from "hooks/useFileUploader";


import {
  INITIAL_STATE,
  templateReducer,
} from "../../../../channels/reducers/templateReducer";
import CustomDelete from "../../../../../assets/customSVG/CustomDelete";

const language = {
  en: "English",
  en_US: "English_US",
  ta: "Tamil",
  en_GB: "English_US",
  te: "Telugu",
  kn: "Kannada",
  bn: "Bengali",
  hi: "Hindi",
  mr: "Marathi",
  ml: "Malayalam",
};

const BroadcastMessageView = ({
  segment,
  onClose,
  setSelectedId3,
  data,
  selectedTemplate,
  setSelectedTemplate,
  products = [],
  availableProducts = [],
  orderDetails = { discount: 0, shipping: 0, tax: 0 },
  onProductChange = () => {},
  onProductSelect = () => {},
  onOrderDetailChange = () => {},
  onRemoveProduct = () => {},
  onAddProduct = () => {}
}) => {
  const handleClose = () => {
    onClose();
    const updatedSegment = { ...segment };
    updatedSegment.settings.template_name = "";
    setSelectedTemplate([]);
    setSelectedId3(false);
  };

  const [templateData, templateDispatch] = useReducer(
    templateReducer,
    INITIAL_STATE
  );

  const { uploading, selectedFile, setSelectedFile, uploadFiles, error } =
    useFileUploader();
  const { custom, carousel, authentication } = templateData;

  const {
    header,
    headerVariable,
    body,
    bodyVariables,
    footer,
    buttons,
    buttonsOrder,
    ctaButtons,
    customButtons,
  } = custom;

  useEffect(() => {
    templateDispatch({
      type: "update_template",
      data: selectedTemplate,
    });
  }, [selectedTemplate]);

  const updateTemplate = (type, key, value) => {
    if (selectedTemplate)
      if (["HEADER", "BODY", "FOOTER", "BUTTONS"].includes(type)) {
        const filterType = selectedTemplate?.components?.filter(
          (c) => c.type === type
        );

        const filterWithoutType = selectedTemplate?.components?.filter(
          (c) => c.type !== type
        );

        const updatedData = {
          ...selectedTemplate,
          components: [
            ...filterWithoutType,
            {
              ...filterType?.[0],
              [key]: value,
            },
          ],
        };
        setSelectedTemplate(updatedData);
      } else {
        setSelectedTemplate({ ...selectedTemplate, [key]: value });
      }
  };

  const fileName = (url) => {
    const names = url?.split("/");
    return names?.[names.length - 1];
  };

  // styles
  const uploadContainer =
    "flex items-center gap-[0.3vw] bg-[var(--primary)] px-[0.5vw] py-[0.1.5vw] cursor-pointer";
  const errorStyle = "text-[var(--fontRed)] font-md weight-400 my-[0.5vw]";

  return (
    <div className="BroadcastMessage-container w-90 space-between flex-row h-full">
      {/* Select Template Section */}
      <div className="broadcast-wrapper w-58 flex-column h-full">
        <div className="select-heading flex-column">
          <span>Select Template</span>
          <span style={{ padding: "0px" }}>
            Select the approved message templates to broadcast your customers.
          </span>
        </div>
        <div className="flex-column w-100 mb-10">
          <>
            <div className="select-template flex-column mt-20 py-2 pb-20">
              <div className=" flex-row w-50 align-center pb-10">
                <img src={images?.BroadcastWhatsappImage} alt="whatsappLogo" />
                <p className="template-name-info">
                  {/* {segment?.settings?.template_name} */}
                  {selectedTemplate?.name}
                </p>
                <span
                  className="status-color flex align-center justify-center"
                  style={{
                    color:
                      selectedTemplate?.category === "MARKETING"
                        ? "#ED4F9D"
                        : "#f6a723",
                    background:
                      selectedTemplate?.category === "MARKETING"
                        ? "#fdf2f8"
                        : "#FFFBEB",
                    padding:
                      selectedTemplate?.category === "MARKETING"
                        ? "5px !important"
                        : "5px !important",
                  }}
                >
                  {selectedTemplate?.category?.charAt(0)?.toUpperCase() +
                    selectedTemplate?.category?.slice(1)?.toLowerCase()}
                </span>
                <p
                  className="status-Language flex-row align-center justify-center pl-5 pr-5"
                  style={{
                    color: "var(--dashboardprimary)",
                    backgroundColor: "hsla(203, 78%, 95%, 1)",
                    borderRadius: "5px",
                    marginLeft: "10px",
                  }}
                >
                  {language[selectedTemplate?.language]}
                </p>
                {data && (
                  <img
                    src={ICONS?.deleteIcon}
                    alt="delete"
                    className="Delay-image"
                    onClick={() => handleClose()}
                    onMouseOver={(e) =>
                      (e.currentTarget.src = ICONS?.BroadcastRedDeleteIcon)
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.src = ICONS?.deleteIcon)
                    }
                  />
                )}
              </div>
            </div>
          </>
        </div>

        {/* Order Details Form - Only show when a template is selected and it's an ORDER_DETAIL type */}
        {selectedTemplate && selectedTemplate?.subcategory_type === 'ORDER_DETAIL' && (
          <div className="flex-column gap-3 p-3 rounded-md border border-gray-200 max-h-[60vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-3">
              <div className="text-sm font-medium text-gray-700">Order Details</div>
            </div>

            {products.map((product, index) => (
              <div key={product.id || index} className="space-y-3 p-3 bg-white rounded border border-gray-200 mb-3">
                <div className="flex items-end gap-3">
                  {/* Product Selection and Name */}
                  <div className="flex-1">
                    <label className="text-xs text-gray-500 block mb-1">Product</label>
                    <select
                      value={product.id || ''}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        onProductSelect(index, selectedId);
                      }}
                      className="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                    >
                      <option value="">Select a product</option>
                      {availableProducts.map((prod) => (
                        <option key={prod.id} value={prod.id}>
                          {prod.name} (₹{prod.price ? parseFloat(prod.price).toFixed(2) : '0.00'})
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Price (Read-only) */}
                  <div className="w-32">
                    <label className="text-xs text-gray-500 block mb-1">Price (₹)</label>
                    <div className="relative">
                      <span className="absolute left-2 top-2 text-gray-400 text-sm">₹</span>
                      <input
                        type="text"
                        value={product.price ? (parseFloat(product.price) * (product.quantity || 1)).toFixed(2) : '0.00'}
                        readOnly
                        className="w-full text-sm p-2 pl-6 border border-gray-200 bg-gray-50 rounded-md"
                      />
                    </div>
                  </div>

                  {/* Quantity */}
                  <div className="w-24">
                    <label className="text-xs text-gray-500 block mb-1">Quantity</label>
                    <div className="flex items-center border border-gray-300 rounded-md overflow-hidden">
                      <button
                        type="button"
                        onClick={() => {
                          const currentQty = parseInt(product.quantity, 10) || 1;
                          const newQuantity = Math.max(1, currentQty - 1);
                          onProductChange(index, 'quantity', newQuantity);
                        }}
                        className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 focus:outline-none"
                        disabled={!product.id}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        min="1"
                        max="100"
                        value={product.quantity || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '') {
                            onProductChange(index, 'quantity', '');
                          } else {
                            const numValue = parseInt(value, 10);
                            if (!isNaN(numValue)) {
                              onProductChange(index, 'quantity', Math.max(1, Math.min(100, numValue)));
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          if (['-', 'e', 'E', '+', '.'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            onProductChange(index, 'quantity', 1);
                          }
                        }}
                        className="w-full text-sm p-2 border-0 text-center focus:ring-1 focus:ring-blue-500"
                        disabled={!product.id}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const currentQty = parseInt(product.quantity, 10) || 0;
                          const newQuantity = Math.min(100, currentQty + 1);
                          onProductChange(index, 'quantity', newQuantity);
                        }}
                        className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 focus:outline-none"
                        disabled={!product.id}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Remove button (only show if more than one product) */}
                  {products.length > 1 && (
                    <button
                      type="button"
                      onClick={() => onRemoveProduct(index)}
                      title="Remove product"
                      className="mb-1 p-1 hover:bg-gray-100 rounded"
                    >
                      <CustomDelete width="1.2vw" height="1.2vw" color="red" fillColors="red" />
                    </button>
                  )}
                </div>
              </div>
            ))}

            {/* Add Product Button */}
            <div className="flex justify-between mt-4">
              <button
                type="button"
                onClick={onAddProduct}
                className="text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1 px-3 py-1.5 border border-blue-200 rounded-md hover:bg-blue-50"
                disabled={products.length >= 5}
                title={products.length >= 5 ? 'Maximum 5 products allowed' : 'Add another product'}
              >
                <span className="text-lg">+</span> Add Product
              </button>
              <div className="text-xs text-gray-500 self-center">
                {products.length}/5 products added
              </div>
            </div>

            {/* Order Summary */}
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <h3 className="text-sm font-medium text-gray-700 mb-3">Order Summary</h3>

              {/* Goods Type */}
              <div className="mb-4">
                <label className="text-xs text-gray-500 block mb-1">Goods Type</label>
                <select
                  value={orderDetails.goods_type || 'digital-goods'}
                  onChange={(e) => onOrderDetailChange('goods_type', e.target.value)}
                  className="w-full max-w-xs text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option value="physical-goods">Physical goods</option>
                  <option value="digital-goods">Digital goods</option>
                </select>
              </div>

              {/* Discount Section */}
              <div className="mb-4 p-4 border border-gray-200 rounded-md">
                <div className="flex justify-between items-center mb-3">
                  <label className="text-sm font-medium text-gray-700">Discount</label>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-500">Type:</span>
                    <select
                      value={orderDetails.discount_type || 'percent'}
                      onChange={(e) => onOrderDetailChange('discount_type', e.target.value)}
                      className="text-xs border border-gray-300 rounded p-1"
                    >
                      <option value="percent">Percentage</option>
                      <option value="fixed">Fixed Amount</option>
                    </select>
                  </div>
                </div>
                <div className="relative mb-2">
                  <span className="absolute left-2 top-2 text-gray-400 text-sm">
                    {orderDetails.discount_type === 'percent' ? '%' : '₹'}
                  </span>
                  <input
                    type="number"
                    min="0"
                    max={orderDetails.discount_type === 'percent' ? '100' : undefined}
                    step={orderDetails.discount_type === 'percent' ? '1' : '1.00'}
                    value={orderDetails.discount ?? ''}
                    onChange={(e) => {
                      const value = e.target.value === '' ? '' : parseFloat(e.target.value);
                      onOrderDetailChange('discount', isNaN(value) ? '' : value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value === '') {
                        onOrderDetailChange('discount', 0);
                      }
                    }}
                    className="w-full text-sm p-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                    placeholder={orderDetails.discount_type === 'percent' ? '0' : '1.00'}
                  />
                  {orderDetails.discount_type === 'percent' && (
                    <div className="flex gap-2 mt-2">
                      {[5, 10, 15, 20].map(percent => (
                        <button
                          key={percent}
                          type="button"
                          onClick={() => onOrderDetailChange('discount', percent)}
                          className={`text-xs px-2 py-1 rounded ${
                            orderDetails.discount === percent
                              ? 'bg-blue-100 text-blue-700'
                              : 'bg-gray-100 hover:bg-gray-200'
                          }`}
                        >
                          {percent}%
                        </button>
                      ))}
                    </div>
                  )}
                  <div className="relative mt-2">
                  <input
                    type="text"
                    value={orderDetails.discount_description || ''}
                    onChange={(e) => {
                      if (e.target.value.length <= 60) {
                        onOrderDetailChange('discount_description', e.target.value);
                      }
                    }}
                    maxLength={60}
                    className="w-full text-xs pr-12 py-2 pl-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200"
                    placeholder="Description (optional)"
                    style={{paddingRight: '4rem'}}
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-400 bg-white px-1">
                    {orderDetails.discount_description?.length || 0}/60
                  </div>
                </div>
                </div>
              </div>

              {/* Shipping Section */}
              <div className="mb-4 p-4 border border-gray-200 rounded-md">
                <label className="text-sm font-medium text-gray-700 block mb-3">Shipping</label>
                <div className="relative mb-2">
                  <span className="absolute left-2 top-2 text-gray-400 text-sm">₹</span>
                  <input
                    type="number"
                    min="0"
                    step="1.00"
                    value={orderDetails.shipping || ''}
                    onChange={(e) => onOrderDetailChange('shipping', parseFloat(e.target.value) || 0)}
                    className="w-full text-sm p-2 pl-6 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                    placeholder="0.00"
                  />
                </div>
                <div className="relative mt-2">
                  <input
                    type="text"
                    value={orderDetails.shipping_description || ''}
                    onChange={(e) => {
                      if (e.target.value.length <= 60) {
                        onOrderDetailChange('shipping_description', e.target.value);
                      }
                    }}
                    maxLength={60}
                    className="w-full text-xs pr-12 py-2 pl-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200"
                    placeholder="Description (optional)"
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-400 bg-white px-1">
                    {orderDetails.shipping_description?.length || 0}/60
                  </div>
                </div>
              </div>

              {/* Tax Section */}
              <div className="mb-4 p-4 border border-gray-200 rounded-md">
                <div className="flex justify-between items-center mb-3">
                  <label className="text-sm font-medium text-gray-700">Tax</label>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-500">Type:</span>
                    <select
                      value={orderDetails.tax_type || 'tax_inclusive'}
                      onChange={(e) => onOrderDetailChange('tax_type', e.target.value)}
                      className="text-xs border border-gray-300 rounded p-1"
                    >
                      <option value="tax_inclusive">Tax Inclusive</option>
                      <option value="tax_exclusive">Tax Exclusive</option>
                    </select>
                  </div>
                </div>
                <div className="relative mb-2">
                  <span className="absolute left-2 top-2 text-gray-400 text-sm">
                    %
                  </span>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={orderDetails.tax || ''}
                    onChange={(e) => onOrderDetailChange('tax', parseFloat(e.target.value) || 0)}
                    className="w-full text-sm p-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                    placeholder="0"
                  />
                  <div className="flex gap-2 mt-2">
                    {[3, 5, 12, 18, 28].map(percent => (
                      <button
                        key={percent}
                        type="button"
                        onClick={() => onOrderDetailChange('tax', percent)}
                        className={`text-xs px-2 py-1 rounded ${
                          orderDetails.tax === percent
                            ? 'bg-blue-100 text-blue-700'
                            : 'bg-gray-100 hover:bg-gray-200'
                        }`}
                      >
                        {percent}%
                      </button>
                    ))}
                  </div>
                </div>
                <div className="relative mt-2">
                  <input
                    type="text"
                    value={orderDetails.tax_description || ''}
                    onChange={(e) => {
                      if (e.target.value.length <= 60) {
                        onOrderDetailChange('tax_description', e.target.value);
                      }
                    }}
                    maxLength={60}
                    className="w-full text-xs pr-12 py-2 pl-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200"
                    placeholder="Description (optional)"
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-400 bg-white px-1">
                    {orderDetails.tax_description?.length || 0}/60
                  </div>
                </div>
              </div>

              {/* Order Total */}
              <div className="mt-4 pt-3">
                {/* <div className="flex justify-between items-center">
                  <span className="text-sm font-medium">Subtotal:</span>
                  <span className="text-sm font-medium">
                    ₹{products.reduce((sum, p) => sum + (p.price || 0) * (p.quantity || 1), 0).toFixed(2)}
                  </span>
                </div>
                {(() => {
                  const subtotal = products.reduce((sum, p) => sum + (parseFloat(p.price) || 0) * (parseInt(p.quantity, 10) || 1), 0);
                  
                  // Calculate discount amount based on type
                  let discountAmount = 0;
                  const discountValue = parseFloat(orderDetails.discount) || 0;
                  
                  if (orderDetails.discount_type === 'percent') {
                    // For percentage, calculate the discount amount
                    discountAmount = subtotal * (discountValue / 100);
                  } else {
                    // For fixed amount, use the value directly
                    discountAmount = discountValue;
                  }
                  
                  // Calculate shipping
                  const shipping = parseFloat(orderDetails.shipping) || 0;
                  
                  // Calculate tax (assuming tax is applied after discount)
                  const taxableAmount = Math.max(0, subtotal - discountAmount);
                  let taxAmount = 0;
                  // if tax is inclusive then we need to reduce the percetage of amount from the items(products)
                  // if tax is exlusive then we need to find the tax amount alone , by using the subtotal * tax percentage
                  if (orderDetails.tax_type === 'tax_inclusive') {
                    taxAmount = taxableAmount * (parseFloat(orderDetails.tax) || 0) / 100;
                  } else if (orderDetails.tax_type === 'tax_exclusive') {
                    taxAmount = (taxableAmount * (parseFloat(orderDetails.tax) || 0)) / 100;
                  }

                  const total = subtotal - discountAmount + shipping + taxAmount;
                  
                  return (
                    <>
                      {discountAmount > 0 && (
                        <div className="flex justify-between items-center text-sm">
                          <span>Discount:</span>
                          <span>
                            -₹{discountAmount.toFixed(2)}
                            {orderDetails.discount_type === 'percent' && 
                              ` (${orderDetails.discount}% of ${subtotal.toFixed(2)})`}
                          </span>
                        </div>
                      )}

                      {shipping > 0 && (
                        <div className="flex justify-between items-center text-sm">
                          <span>Shipping:</span>
                          <span>+₹{shipping.toFixed(2)}</span>
                        </div>
                      )}

                      {taxAmount > 0 && (
                        <div className="flex justify-between items-center text-sm">
                          <span>Tax ({orderDetails.tax_type === 'percent' ? `${orderDetails.tax}%` : 'Fixed'}):</span>
                          <span>+₹{taxAmount.toFixed(2)}</span>
                        </div>
                      )}

                      <div className="flex justify-between items-center mt-2 pt-2 border-t border-gray-200">
                        <span className="font-medium">Total:</span>
                        <span className="text-base font-semibold">
                          ₹{total.toFixed(2)}
                        </span>
                      </div>
                    </>
                  );
                })()} */}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Message Preview Section */}
      <div className="MessagePreview">
        <div className="TestMessage">
          <p className="flex-row align-center">Message Preview</p>
        </div>
        <div className="w-full min-h-[65vh] max-h-[70vh] h-full">
          <div className="w-[18vw] min-h-[57vh] max-h-[59vh] border-[0.4vw] border-[var(--white)] rounded-[2vw] my-[0.7vw] shadow-[0px_4px_30px_0px_#2D303620]">
            <div className="h-[6vh] flex items-center gap-[0.5vw] bg-[#077C70] rounded-t-[1.5vw] px-[0.6vw]">
              <div className="size-[2.1vw] bg-[var(--white)] rounded-full flex items-center justify-center font-xs">
                Logo
              </div>
              <div className="text-[var(--white)]">
                <h3 className="font-md weight-bold capitalize leading-[1.2vw]">
                  {segment?.settings?.send_from_phone_name}
                </h3>
                <span className="font-md weight-bold capitalize flex-row leading-[1.2vw]">
                  {segment?.settings?.country_code}
                  <p className="pl-5">
                    {segment?.settings?.send_from_phone_number}
                  </p>
                </span>
              </div>
            </div>
            <TemplatePreview
              header={header}
              headerVariable={headerVariable}
              body={body}
              bodyVariables={bodyVariables}
              footer={footer}
              buttons={buttons}
              buttonsOrder={buttonsOrder}
              ctaButtons={ctaButtons}
              customButtons={customButtons}
              carousel={carousel}
              authentication={authentication}
              category={selectedTemplate?.subcategory_type}
              data={selectedTemplate}
              className={"rounded-none min-h-[45vh] max-h-[45vh]"}
              drawerType="small"
              products={products.filter(p => p.id)}
              orderDetails={orderDetails}
              businessName={segment?.settings?.send_from_phone_name || ''}
            />
            <img
              src={images?.TemplatePreviewBottom}
              alt="send msg"
              className="w-[17.35vw] h-[2.3vw] rounded-b-[1.5vw]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastMessageView;
